/**
 * Overview:
 * Manages role and widget display name mappings and provides helper functions for loading and retrieving mapped values.
 */
import { getMaps } from "@/services/widgets";

export let ROLE_NAME_MAP: Record<string, string> = {};

export let WIDGET_NAME_MAP: Record<string, string> = {};

export let WIDGET_CODE_MAP: Record<string, string> = {};

export async function loadMaps(): Promise<void> {
  const data = await getMaps();

  ROLE_NAME_MAP = data.roleMap ?? {};

  WIDGET_NAME_MAP = data.featureMap ?? {};

  WIDGET_CODE_MAP =
    data.featureCodeMap ??
    Object.fromEntries(Object.entries(WIDGET_NAME_MAP).map(([key, value]) => [value, key]));
}

export function getRoleDisplayName(roleCode: string): string {
  return ROLE_NAME_MAP[roleCode] ?? roleCode;
}

export function getWidgetDisplayName(featureCode: string): string {
  return WIDGET_NAME_MAP[featureCode] ?? featureCode;
}

export function getWidgetCode(displayName: string): string {
  return WIDGET_CODE_MAP[displayName] ?? displayName;
}
